// TS twin of iOS `WheelDetails`.
// Domain projection of the assembler response — produced by AssemblerService
// at the network/domain boundary. Plain value type; no parse logic here.

import type { WheelSize } from '@/models/wheel-size'

export interface WheelDetails {
  readonly partID: number | null
  readonly brandName: string
  readonly modelName: string
  readonly brandLogoURL: URL | null
  /** Dark-mode brand mark. Brands carry both variants; a dark chrome
   *  renders this one when present and plates the light one when not
   *  (2026-08-21). */
  readonly brandLogoDarkURL: URL | null
  readonly sizes: readonly WheelSize[]
  readonly assembledSize: WheelSize | null
  /** ADR-104 — `sizes` is what the wheel is SOLD in (an offered set), not
   *  what its mesh was modeled in, so its first entry is no stand-in for
   *  the wheel's own size. */
  readonly sizesAreOffered: boolean
}

export function wheelDetails(fields: {
  partID?: number | null
  brandName: string
  modelName: string
  brandLogoURL?: URL | null
  brandLogoDarkURL?: URL | null
  sizes?: readonly WheelSize[]
  assembledSize?: WheelSize | null
  sizesAreOffered?: boolean
}): WheelDetails {
  return {
    partID: fields.partID ?? null,
    brandName: fields.brandName,
    modelName: fields.modelName,
    brandLogoURL: fields.brandLogoURL ?? null,
    brandLogoDarkURL: fields.brandLogoDarkURL ?? null,
    sizes: fields.sizes ?? [],
    assembledSize: fields.assembledSize ?? null,
    sizesAreOffered: fields.sizesAreOffered ?? false,
  }
}
